var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPalmTree = function SvgPalmTree(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m4.526 4.856.947 1.578q-.187.164-.375.35c-2.22 2.22-1.882 4.72-1.022 5.978.156.229.475.229.669.032l4.328-4.328c.125.337.243.818.303 1.475.131 1.453-.05 3.65-1.022 6.762A.998.998 0 0 0 9.31 18h2c.503 0 .931-.375.994-.875.387-3.094-.072-6.475-.99-9.125h3.956a.26.26 0 0 0 .215-.122l.613-1.022a.25.25 0 0 1 .428 0l.612 1.022a.25.25 0 0 0 .216.122h1.456c.275 0 .503-.225.45-.497C18.976 6.006 17.448 4 14.31 4c-1.366 0-2.425.381-3.212.931C10.576 3.544 9.06 2 6.31 2 3.173 2 1.645 4.006 1.36 5.503c-.053.272.175.497.45.497h1.46a.26.26 0 0 0 .215-.122l.61-1.022a.25.25 0 0 1 .428 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPalmTree);
export default ForwardRef;